import React, { Fragment, useEffect, useState } from "react";
import { Table, UncontrolledTooltip } from "reactstrap";
import { useSelector } from "react-redux";
import moment from "moment";

import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { getTexts } from "../../../../reducers/selectors";

import style from "./AssetTable.scss";

export const AssetTable = ({ subAssetClass, toggle, position, currency, portfolioTotal }) => {
  const [totalMarketValue, setTotalMarketValue] = useState(0);
  const [totalInvestmentCost, setTotalInvestmentCost] = useState(0);
  const [totalAbsoluteReturn, setTotalAbsoluteReturn] = useState(0);
  const [totalYTM, setTotalYTM] = useState(0);
  const [totalPortfolio, setTotalPortfolio] = useState(0);
  const texts = useSelector(getTexts);
  const tooltTipStyles = {
    color: "white",
    backgroundColor: "#003399",
  };

  useEffect(() => {
    let totalMarketValue = 0;
    let totalInvestmentCost = 0;
    let totalAbsoluteReturn = 0;
    let totalYTM = 0;
    let totalPortfolio = 0;

    subAssetClass.asset.forEach((asset) => {
      let investCost = (+asset.NetReturn - (+asset.valuetotal + +asset.realizePL)) * -1;
      totalMarketValue += parseFloat(asset.totalOriginCurrencyWithCoupon);
      totalInvestmentCost += parseFloat(investCost);
      totalAbsoluteReturn += parseFloat(asset.TRT);
      totalYTM += parseFloat(asset.YTM);
      totalPortfolio += (+asset.totalUSDWithCoupon * 100) / +portfolioTotal;
    });
    setTotalMarketValue(totalMarketValue);
    setTotalInvestmentCost(totalInvestmentCost);
    setTotalAbsoluteReturn(totalAbsoluteReturn);
    setTotalYTM(totalYTM);
    setTotalPortfolio(totalPortfolio);
  }, []);

  return (
    <Table>
      <table className={style.table}>
        <thead>
          <tr className={style.tableRow}>
            <th className={style.grayTableH} id="marketPrice">
              <UncontrolledTooltip
                placement="right"
                target="marketPrice"
                className={style.toolTip}
                style={tooltTipStyles}
              >
                {texts.tooltips.portfolio_actual_price}
              </UncontrolledTooltip>
              Último precio de mercado
            </th>
            <th className={`${style.grayTableH} ${style.xs}`}>Cantidad</th>
            <th className={style.grayTableH} id="marketValue">
              <UncontrolledTooltip
                placement="right"
                target="marketValue"
                className={style.toolTip}
                style={tooltTipStyles}
              >
                {texts.tooltips.portfolio_nominal_value}
                inversión
              </UncontrolledTooltip>
              Valor de mercado
            </th>
            <th className={`${style.grayTableH} ${style.xs}`} id="investmentCost">
              <UncontrolledTooltip
                placement="right"
                target="investmentCost"
                className={style.toolTip}
                style={tooltTipStyles}
              >
                {texts.tooltips.portfolio_investment_cost}
              </UncontrolledTooltip>
              Costo de inversión
            </th>
            <th className={`${style.grayTableH} ${style.sm} ${style.xs}`} id="interest">
              <UncontrolledTooltip
                placement="right"
                target="interest"
                className={style.toolTip}
                style={tooltTipStyles}
              >
                {texts.tooltips.portfolio_pl}
              </UncontrolledTooltip>
              Interés/ dividendo acumulado
            </th>
            <th className={`${style.grayTableH} ${style.md} ${style.sm} ${style.xs}`} id="absolutReturn">
              <UncontrolledTooltip
                placement="right"
                target="absolutReturn"
                className={style.toolTip}
                style={tooltTipStyles}
              >
                {texts.tooltips.portfolio_trt}
              </UncontrolledTooltip>
              Retorno absoluto
            </th>
            <th className={`${style.grayTableH} ${style.lg} ${style.md} ${style.sm} ${style.xs}`} id="ytm">
              <UncontrolledTooltip
                placement="right"
                target="ytm"
                className={style.toolTip}
                style={tooltTipStyles}
              >
                {texts.tooltips.portfolio_ytm}
              </UncontrolledTooltip>
              YTM
            </th>
            <th
              className={`${style.grayTableH} ${style.xl} ${style.lg} ${style.md} ${style.sm} ${style.xs}`}
              id="percentaje"
            >
              <UncontrolledTooltip
                placement="right"
                target="percentaje"
                className={style.toolTip}
                style={tooltTipStyles}
              >
                {texts.tooltips.portfolio_percentage}
              </UncontrolledTooltip>{" "}
              Portafolio
            </th>
            <th className={style.grayTableH}></th>
          </tr>
        </thead>
        <tbody>
          {subAssetClass.asset.map((asset, itemIndex) => (
            <AssetRow
              key={itemIndex}
              position={position}
              asset={asset}
              toggle={toggle}
              currency={currency}
              portfolioTotal={portfolioTotal}
            />
          ))}
        </tbody>
        <tfoot>
          <tr className={style.tableRow}>
            <th className={`${style.grayTableH} ${style.xs}`}></th>
            <th className={style.grayTableH}>subTotal</th>
            <th className={style.grayTableH}>
              <FormattedNumber
                value={totalMarketValue}
                minimumFractionDigits={currency == "USD" ? 2 : 0}
                maximumFractionDigits={currency == "USD" ? 2 : 0}
              />
            </th>
            <th className={`${style.grayTableH} ${style.xs}`}>
              <FormattedNumber
                value={totalInvestmentCost}
                minimumFractionDigits={currency == "USD" ? 2 : 0}
                maximumFractionDigits={currency == "USD" ? 2 : 0}
              />
            </th>
            <th className={`${style.grayTableH} ${style.sm} ${style.xs}`}></th>
            <th className={`${style.grayTableH} ${style.sm} ${style.md} ${style.xs}`}>
              <FormattedNumber
                value={totalAbsoluteReturn}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
              />
            </th>
            <th className={`${style.grayTableH} ${style.lg} ${style.md} ${style.sm} ${style.xs}`}>
              <FormattedNumber value={totalYTM} minimumFractionDigits={2} maximumFractionDigits={2} />%
            </th>
            <th
              className={`${style.grayTableH} ${style.xl}  ${style.lg} ${style.md} ${style.sm} ${style.xs}`}
            >
              <FormattedNumber value={totalPortfolio} minimumFractionDigits={2} maximumFractionDigits={2} />%
            </th>
            <th className={`${style.grayTableH}`}></th>
          </tr>
        </tfoot>
      </table>
    </Table>
  );
};

const getName = (name) => {
  let res = name.split(" ");
  res = res[0] + " " + res[3];
  return res;
};

const AssetRow = ({ position, asset, toggle, currency, portfolioTotal }) => {
  const investCost = (+asset.NetReturn - (+asset.valuetotal + +asset.realizePL)) * -1;

  return (
    <Fragment>
      <tr className={style.assetName}>
        <td colSpan="8">{asset.name}</td>
      </tr>
      <tr className={style.assetIsin}>
        <td colSpan="8">ISIN {asset.isin}</td>
      </tr>
      <tr className={style.tableRow}>
        <td className={style.td}>
          <FormattedNumber value={asset.actualPrice} minimumFractionDigits={4} maximumFractionDigits={4} />
        </td>
        <td className={`${style.td} ${style.xs}`}>
          <FormattedNumber value={asset.nominalValue} minimumFractionDigits={0} maximumFractionDigits={8} />
        </td>
        <td className={style.td}>
          <FormattedNumber
            value={asset.totalOriginCurrencyWithCoupon}
            minimumFractionDigits={currency == "USD" ? 2 : 0}
            maximumFractionDigits={currency == "USD" ? 2 : 0}
          />
        </td>
        <td className={`${style.td} ${style.xs}`}>
          <FormattedNumber
            value={investCost}
            minimumFractionDigits={currency == "USD" ? 2 : 0}
            maximumFractionDigits={currency == "USD" ? 2 : 0}
          />
        </td>
        <td className={`${style.td} ${style.sm} ${style.xs}`}>
          <FormattedNumber value={asset.realizePL} minimumFractionDigits={2} maximumFractionDigits={2} />
        </td>
        <td className={`${style.td} ${style.md} ${style.sm} ${style.xs}`}>
          <FormattedNumber value={asset.TRT} minimumFractionDigits={2} maximumFractionDigits={2} />
        </td>
        <td className={`${style.td} ${style.lg} ${style.md} ${style.sm} ${style.xs}`}>
          <FormattedNumber value={asset.YTM} minimumFractionDigits={2} maximumFractionDigits={2} />%
        </td>
        <td className={`${style.td} ${style.xl} ${style.lg} ${style.md} ${style.sm} ${style.xs}`}>
          <FormattedNumber
            value={(+asset.totalUSDWithCoupon * 100) / +portfolioTotal}
            minimumFractionDigits={2}
            maximumFractionDigits={2}
          />
          %
        </td>
        <td className={style.td}>
          {/* <a
            className={style.sellModal}
            onClick={() => {
              toggle(asset, asset.nominalValue);
            }}
          >
            vender
          </a> */}
        </td>
      </tr>
    </Fragment>
  );
};
